<template lang="pug">
.new-knowledge-base
   .inline-intro {{ $t(`${BaseTranslationPath}.header`) }}
    search-container(name="assets"
                       :config="kbConfig" @search='onSearch')
</template>
<script>
import SearchContainer from './SearchContainer.vue';
import { mapState } from 'vuex';

export default {
  name: 'new-knowledge-base',
  data() {
    return {
      BaseTranslationPath: 'conversation_tab.side_panel.knowledge_base_accordion',
    };
  },
  components: {
    SearchContainer,
  },
  computed: {
    ...mapState({
      selectedConversation: state => state.conversations.selected,
      mode: state => state.conversations.KBMode.name,
      kbItems: state => state.conversations.KBMode.items,
      kbConfig: state => state.conversations.KBMode,
      kbType: state => state.conversations.KBMode.type,
    }),
  },
  methods: {
    onSearch(_keyword) {
      //todo: valentine implement new seartch
    },
  },
};
</script>
<style lang="scss" scoped>
.inline-intro {
  padding-bottom: 0rem;
}
.new-knowledge-base {
    padding: 16px;
}
</style>